import React from 'react';
import { Field, RadioGroup, TextOutput } from '../../Core';
import { ListFieldSection, PageSection } from '../../Layout';

const GroovingToolEquipment = () => {
  return (
    <>
      <PageSection heading="Grooving Tool">
        <ListFieldSection>
          <Field input={<TextOutput />} label="Grooving Tool" name="Code" />
          <Field
            input={<RadioGroup />}
            label="Material"
            name="Type"
            options={[
              { label: 'Metal', value: 'Metal' },
              { label: 'Plastic', value: 'Plastic' },
            ]}
          />
          <Field
            input={<RadioGroup />}
            label="Shape"
            name="Shape"
            options={[
              { label: 'Flat', value: 'Flat' },
              { label: 'Curved', value: 'Curved' },
            ]}
          />
        </ListFieldSection>
      </PageSection>
    </>
  );
};

export default GroovingToolEquipment;
export { GroovingToolEquipment };
